import {
  Box,
  Button,
  CircularProgress,
  Grid2,
  Modal,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import ErrorModal from "../../../../utils/ErrorModal";
import { viewPDF } from "../../../../utils/viewPDF";
import SuccessModal from "../../../../utils/SuccessModal";
import { handleExportPreviewPDF } from "../../../../utils/exportToPDF";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const PreviewVendorBalance = ({
  sra,
  setStep,
  storedUser,
  approvers,
  fileNames,
  noOfApprovers,
}) => {
  const [draft, setDraft] = useState();
  const [approversData, setApproversData] = useState({
    approver1: "",
    approver2: "",
    approver3: "",
    approver4: "",
  });
  const [open, setOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [msg, setMsg] = useState();
  const handleClose = () => setOpen(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [draftLoading, setDraftLoading] = useState(true);
  const [approverLoading, setApproverLoading] = useState(true);
  const [errorModal, setErrorModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState();
  const [exporting, setExporting] = useState(false);
  const pdfRef = useRef();
  const type = JSON.parse(localStorage.getItem("type"));

  useEffect(() => {
    const getDraft = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft-vendor-balance?draftSraId=${sra.draftVendorBalanceId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraft(res.data);
      } catch (error) {
        console.log(error);
      } finally {
        setDraftLoading(false);
      }
    };

    getDraft();
  }, []);

  useEffect(() => {
    const selectedApprovers = {
      approver1: approvers[0],
      approver2: approvers[1] || null,
      approver3: approvers[2] || null,
      approver4: approvers[3] || null,
    };
    const fetchApprovers = async () => {
      try {
        let approver2Name = "N/A";
        let approver3Name = "N/A";
        let approver4Name = "N/A";

        if (selectedApprovers.approver2) {
          const res1 = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/org-user?username=${approvers[1]}`,
            {
              headers: { Authorization: `Bearer ${storedUser.accessToken}` },
            }
          );
          approver2Name = res1.data.name || "N/A";
        }
        if (selectedApprovers.approver3) {
          const res1 = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/org-user?username=${approvers[2]}`,
            {
              headers: { Authorization: `Bearer ${storedUser.accessToken}` },
            }
          );
          approver3Name = res1.data.name || "N/A";
        }
        if (selectedApprovers.approver4) {
          const res1 = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/org-user?username=${approvers[3]}`,
            {
              headers: { Authorization: `Bearer ${storedUser.accessToken}` },
            }
          );
          approver4Name = res1.data.name || "N/A";
        }

        const res2 = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/org-user?username=${approvers[0]}`,
          {
            headers: { Authorization: `Bearer ${storedUser.accessToken}` },
          }
        );

        setApproversData({
          approver1: res2.data.name,
          approver2: approver2Name,
          approver3: approver3Name,
          approver4: approver4Name,
        });
      } catch (error) {
        console.error(error);
      } finally {
        setApproverLoading(false);
      }
    };

    fetchApprovers();
  }, [sra]);

  const handleNext = async () => {
    setBtnLoading(true);
    try {
      const indexedData = approvers.map((item, index) => ({
        username: item,
        number: index + 1,
        numberOfApprovers: noOfApprovers,
      }));
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-balance`,
        {
          username: storedUser.username,
          draftVendorBalanceId: draft.draftVendorBalanceId,
          title: draft.title,
          sapNumber: draft.sapNumber,
          writeType: type,
          code: draft.code,
          name: draft.name,
          amount: draft.amount,
          details: draft.details,
          reason: draft.reason,
          attachment1: draft.attachment1,
          attachment1Filename: fileNames.attachment1Filename,
          attachment2: draft.attachment2,
          attachment2Filename: fileNames.attachment2Filename,
          attachment3: draft.attachment3,
          attachment3Filename: fileNames.attachment3Filename,
          approverRequests: indexedData,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      //   await axios.delete(
      //     `${process.env.REACT_APP_BACKEND_URL}/draft?draftSraId=${draft.draftSraId}`,
      //     { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      //   );
      setBtnLoading(false);
      setOpenConfirm(false);
      setOpen(true);
      setMsg(`Write ${type} Vendor Balance sent for approval.`);
    } catch (error) {
      console.log(error);
      setBtnLoading(false);
      setOpenConfirm(false);
      setErrorModal(true);
      setErrorMsg(error.response?.data?.Exception || "Failed to create form.");
    }
  };

  const handleBack = () => {
    setStep((prev) => prev - 1);
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && (
        <div className="loading-div uploading-div">
          Submitting Vendor Balance... <CircularProgress color="#fff" />
        </div>
      )}
      {exporting && (
        <div className="uploading-div">
          Exporting PDF, this may take a while.{" "}
          <CircularProgress color="#fff" />
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "end", gap: 10 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button className="btn-contained" onClick={() => setOpenConfirm(true)}>
          Submit
        </Button>
        <Button
          className="btn-contained"
          sx={{ width: "200px" }}
          onClick={async () => {
            try {
              setExporting(true);
              await handleExportPreviewPDF(pdfRef, `Write ${type} Vendor Balance`);
            } catch (error) {
              console.log(error);
            } finally {
              setExporting(false);
            }
          }}
        >
          Export PDF
        </Button>
      </div>
      <div ref={pdfRef}>
        <Box className="dashboard-container" px={10}>
      <h2>Preview Write {type} - Vendor Balance Form</h2>
          <Typography className="form-title">Details</Typography>
          {draftLoading ? (
            <Box>Loading...</Box>
          ) : (
            <Grid2 container>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{ borderTop: "1px solid #000" }}
              >
                Title
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{
                  borderTop: "1px solid #000",
                  borderRight: "1px solid #000",
                }}
              >
                {draft?.title || "N/A"}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                SAP Document Number
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{
                  borderRight: "1px solid #000",
                }}
              >
                {draft?.sapNumber || "N/A"}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                Vendor Code
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{
                  borderRight: "1px solid #000",
                }}
              >
                {draft?.code || "N/A"}
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                Vendor Name
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{ borderRight: "1px solid #000" }}
              >
                {draft?.name || "N/A"}
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                Total Amount
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{ borderRight: "1px solid #000" }}
              >
                {draft?.amount || "N/A"}
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                Vendor Details
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{ borderRight: "1px solid #000" }}
              >
                {draft?.details || "N/A"}
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                Reason For Write Off/Back
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{ borderRight: "1px solid #000" }}
              >
                {draft?.reason || "N/A"}
              </Grid2>

              {[1, 2, 3].map((num) => (
                <>
                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Attachment {num}
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {draft?.[`attachment${num}`] ? (
                      <Button
                        sx={{
                          margin: "0 !important",
                          padding: "0 !important",
                          width: "max-content !important",
                          fontSize: "12px !important",
                          textDecoration: "underline",
                          textAlign: "start",
                        }}
                        onClick={() =>
                          viewPDF(draft?.[`attachment${num}`], storedUser)
                        }
                      >
                        <Box
                          component="span"
                          sx={{
                            display: "inline-block",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            maxWidth: "100%",
                          }}
                        >
                          {fileNames?.[`attachment${num}Filename`]}
                        </Box>
                      </Button>
                    ) : (
                      "N/A"
                    )}
                  </Grid2>
                </>
              ))}
            </Grid2>
          )}
        </Box>

        <Box className="dashboard-container" px={10}>
          <Typography variant="h6">Approvers</Typography>
          {approverLoading ? (
            <Box>Loading...</Box>
          ) : (
            <Grid2 container>
              {approversData &&
                Object.entries(approversData).map(([key, name], index) => (
                  <React.Fragment key={index}>
                    <Grid2
                      size={{ xs: 12, sm: 6 }}
                      className="preview-grid"
                      sx={index === 0 ? { borderTop: "1px solid #000" } : {}}
                    >
                      APPROVER {index + 1}
                    </Grid2>
                    <Grid2
                      size={{ xs: 12, sm: 6 }}
                      className="preview-grid"
                      sx={{
                        borderRight: "1px solid #000",
                        ...(index === 0 && { borderTop: "1px solid #000" }),
                      }}
                    >
                      {name || "N/A"}
                    </Grid2>
                  </React.Fragment>
                ))}
            </Grid2>
          )}
        </Box>
      </div>

      <div style={{ display: "flex", justifyContent: "center", gap: 20 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button className="btn-contained" onClick={() => setOpenConfirm(true)}>
          Submit
        </Button>
      </div>

      <Modal
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you sure you want to submit these details?
          </Typography>
          <Box className="btn-container" sx={{ gap: 3, width: "100%" }}>
            <Button
              className="btn-outlined"
              variant="outlined"
              onClick={() => setOpenConfirm(false)}
            >
              No
            </Button>
            <Button
              className="btn-contained"
              onClick={handleNext}
              disabled={btnLoading}
            >
              {btnLoading ? "Submitting..." : "Yes"}
            </Button>
          </Box>
        </Box>
      </Modal>

      <SuccessModal
        open={open}
        handleClose={handleClose}
        msg={msg}
        nav={"/dashboard"}
      />

      <ErrorModal
        open={errorModal}
        handleClose={() => setErrorModal(false)}
        msg={errorMsg}
      />
    </div>
  );
};

export default PreviewVendorBalance;
